<template>
 <!--
	 I have implemented a rudimentary GUI to test, beyond making it look decent we also need to:
	 - Better handle subscription states (see: Org::getSubscriptionAttribute)
	 - Allow billing email to be updated without updating card details (can use PUT /orgs endpoint)
	 - Show spinner/loader icon whilst updating card details?
	 - Show how much they are/will be charged
 -->

	<div>

		<div class="raised-box p-page-more t-center" v-if="!org.subscription.subscribed" >
			<template v-if="org.subscription.status === 'trialing'" >
				<!-- <h2>Add a payment card now to keep {{ dsplApostrophize(org.name) }} Configaro working when your trial ends {{ trialEndsAt }}.</h2>
				<p>Your first payment will be taken after your trial ends.</p> -->
				<h2>Active your account now to keep {{ dsplApostrophize(org.name) }} Configaro working when your trial ends {{ trialEndsAt }}.</h2>
				<p><button @click="Event.$emit('activate-org',org)" class="btn-a btn-big" >Activate account</button></p>
			</template>
			<template v-else >
				<h2>Re-activate {{ dsplApostrophize(org.name) }} Configaro account now</h2>
				<p>Your trial has ended, but that doesn't mean the end for your time with Configaro! Add your card details now to reactivate {{ dsplApostrophize(org.name) }} account.</p>
				<p><button @click="Event.$emit('activate-org',org)" class="btn-alert btn-big" >Activate Account</button></p>
			</template>
			
		</div>

		<template v-else>
			<div class="cols cl-spaced">
				<div class="cl" >
					<div class="raised-box p-box" >
							<h2>Subscription</h2>
							<div v-if="org.subscription.status === 'active'"  >
								<p class="flat-box p-box-less" ><i class="fa fa-check c-active btn_icon"></i>{{ dsplApostrophize(org.name) }} subscription is active.</p>
								<p><button class="btn-outline-warning btn-smaller" @click="openCancelSubscription()" >Cancel account</button></p>
							</div>
							<p v-else>
								You're subscription status is: {{ org.subscription.status }}.
							</p>
					</div>
				</div>
				<div class="cl" >
					<div class="raised-box p-box" >
						<h2>Payment method</h2>
						<div v-if="org.subscription.subscribed">
							<p>Your subscription payment is taken through this payment card once per month:</p>
							<div class="BillingPaymentCard">
								<div class="card">
									<span class="brand" >
										{{ titleCase(org.subscription.card_brand) }}
									</span>
									<span class="number">
										**** **** **** {{ org.subscription.card_last_four }}
									</span>
								</div>
								<div class="options">
									<button @click="openChangeCard()" class="btn-subtle" >Change Card</button>
								</div>
							</div>
						</div>
						<div v-else>
							<button @click="Event.$emit('activate-org',org)" class="btn-alert" >Add card</button>
						</div>
					</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>

	import moment from 'moment';
	import ChangeCard from '../../modals/ChangeCard';
	import CancelSubscription from '../../modals/CancelSubscription';

	export default {
		components : {
		},
		props : [
			'org',
		],
		data() {
			return {
				Event,
				trialCalendarFormat: {
					sameDay: '[Today]',
					nextDay: '[Tomorrow]',
					nextWeek: 'dddd Do MMMM',
					lastDay: '[Yesterday]',
					lastWeek: '[Last] dddd',
					sameElse: 'dddd Do MMMM'
				},
			}
		},
		watch: {
			updating(newUpdating, oldUpdating) {
				if (!newUpdating) return;
			}
		},
		computed: {
			trialEndsAt() {
				return moment(this.org.subscription.trial_ends_at).calendar(null, this.trialCalendarFormat)
			},
		},
		methods: {
			
			openChangeCard(){
				Event.$emit('modal-open', {
					component : ChangeCard,
					props : {
						org : this.org,
					}
				});
			},
			
			openCancelSubscription(){
				Event.$emit('modal-open', {
					component : CancelSubscription,
					props : {
						org : this.org,
					}
				});
			},

		}
	}
</script>
